import { Injectable, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { DialogsService } from "src/app/core/services/dialogs.service";
import { CreateMunicipalityDialogComponent } from "../common/dialogs/create-municipality/create-municipality-dialog.component";

@Injectable({ providedIn: "root" })
export class CreateMunicipalityDialogService {
  private readonly dialogsService = inject(DialogsService);

  open(): MatDialogRef<unknown, boolean> {
    return this.dialogsService.open(CreateMunicipalityDialogComponent, {
      width: "640px",
      panelClass: ["create-municipality-dialog", "rounded"],
      autoFocus: false
    });
  }
}
